/* eslint-disable */
import * as Types from './types';

import { NotFoundHeroFragmentDoc } from './NotFoundHero';
import { ImageFragmentDoc } from './Image';
import { ManualProductRecommendationsFragmentDoc } from './ManualProductRecommendations';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type NotFoundQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type NotFoundQuery = { __typename?: 'Query', notFound?: { __typename?: 'NotFound', seoTitle?: string | null, seoDescription?: string | null, sectionsCollection?: { __typename?: 'NotFoundSectionsCollection', total: number, items: Array<{ __typename: 'CollectionFeaturedListingSection' } | { __typename: 'CollectionListingSection' } | { __typename: 'CollectionVideoSection' } | { __typename: 'CreatorOfMonth' } | { __typename: 'FindYourSystem' } | { __typename: 'MainHero' } | { __typename: 'ManualProductRecommendations', title?: string | null, description?: string | null, descriptionLinkUrl?: string | null, descriptionLinkText?: string | null, descriptionLinkOpenLinkInNewTab?: boolean | null, ctaText?: string | null, ctaUrl?: string | null, openLinkInNewTab?: boolean | null, enableBackground?: boolean | null, filters?: string | null, proContent?: boolean | null, ruleContext?: string | null, recommendationsType?: string | null, collection?: { __typename?: 'Collection', title?: string | null, handle?: string | null, id?: string | null } | null } | { __typename: 'ModuleServiceEducationListing' } | { __typename: 'NailArtSection' } | { __typename: 'NotFoundHero', title?: string | null, subtitle?: string | null, message?: string | null, buttonLink?: string | null, buttonText?: string | null, openLinkInNewTab?: boolean | null, desktopImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, mobileImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | { __typename: 'SectionHelloWorld' } | { __typename: 'ShareYourLooks' } | { __typename: 'SliderHero' } | { __typename: 'VideoHero' } | null> } | null } | null };

export declare const notFound: import("graphql").DocumentNode;

export const NotFoundDocument = /*#__PURE__*/ `
    query notFound($id: String = "5hCO1v6XaH9l8cH235RbLQ", $locale: String = "en-US", $preview: Boolean = false) {
  notFound(id: $id, locale: $locale, preview: $preview) {
    seoTitle
    seoDescription
    sectionsCollection(preview: $preview, where: {sys: {id_exists: true}}) {
      total
      items {
        __typename
        ... on NotFoundHero {
          ...NotFoundHeroFragment
        }
        ... on ManualProductRecommendations {
          ...ManualProductRecommendationsFragment
        }
      }
    }
  }
}
    ${NotFoundHeroFragmentDoc}
${ImageFragmentDoc}
${ManualProductRecommendationsFragmentDoc}`;
export const useNotFoundQuery = <
      TData = NotFoundQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: NotFoundQueryVariables,
      options?: UseQueryOptions<NotFoundQuery, TError, TData>
    ) =>
    useQuery<NotFoundQuery, TError, TData>(
      variables === undefined ? ['notFound'] : ['notFound', variables],
      fetcher<NotFoundQuery, NotFoundQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, NotFoundDocument, variables, options),
      options
    );

useNotFoundQuery.getKey = (variables?: NotFoundQueryVariables) => variables === undefined ? ['notFound'] : ['notFound', variables];
;

useNotFoundQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: NotFoundQueryVariables, options?: RequestInit['headers']) => fetcher<NotFoundQuery, NotFoundQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, NotFoundDocument, variables, options);